import { NvIconModule } from 'Src/nvps-libraries/design/nv-icon/nv-icon.module';
import { PanelTableComponent } from './panel-table.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [PanelTableComponent],
  imports: [CommonModule, NvIconModule],
  exports: [PanelTableComponent],
  providers: [],
})
export class PanelTableModule {}
